import Vue from 'vue';
import Router from 'vue-router';
// import Home from '../layout/Home.vue';
// import global from './global/index';
// import drugControl from './drugControl/index';
// import feeDispense from './feeDispense/index';
// import clinicManagement from './clinicManagement/index';
// import member from './member/index';
// import outPatient from './outPatient/index';
// import statistics from './statistics/index';
import views from '@/views/';
import Store from '@/store/index';

Vue.use(Router);
const baseRoute = [{
  path: '/',
  name: 'index',
  redirect: '/login',
  meta: {
    icon: '',
  },
  menuHidden: true,
},
{
  path: '/login',
  name: 'login',
  meta: {
  },
  label: '登录',
  component: views.global.login,
  menuHidden: true,
},
{
  component: views.global.registe,
  label: '申请注册',
  path: '/registe',
  name: 'registe',
  id: 37,
  menuHidden: true,
},
{
  component: views.global.forgetPwd,
  label: '忘记密码',
  path: '/forgetPwd',
  name: 'forgetPwd',
  id: 37,
  menuHidden: true,
},
];

const router = new Router({
  routes: baseRoute,
});

router.beforeEach((to, from, next) => {
  // console.log(from);
  // 防止在已登录的状态下进入登录页面
  if (to.name === 'login' && Store.state.global.isLogin && from.path !== '/') {
    next(false);
    return;
  }
  next();
});

// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
// Router.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }
// replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export default router;
